import styled from 'styled-components';

import { Table, TableRow } from '@mui/material';

export const Container = styled.div`
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export const InfoCard = styled.div`
  background-color: ${({ theme }) => theme.colors.blacks.ipBlack7};
  border-radius: ${({ theme }) => theme.borders.radius.weak};
  padding: 12px 14px;
  margin-bottom: 24px;
`;

export const InfoText = styled.div`
  color: ${({ theme }) => theme.colors.greys.darker};
  font: ${({ theme }) => theme.fonts.textSmallHeight16};
`;

export const Title = styled.div`
  font: ${({ theme }) => theme.fonts.h1InterNonBold};
  color: ${({ theme }) => theme.colors.greys.darkest};
`;

export const SectionTitle = styled.div`
  font: ${({ theme }) => theme.fonts.h2Inter};
  color: ${({ theme }) => theme.colors.greys.darkest};
`;

export const StoreRestrictionSection = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
`;

export const StoreRestrictionControls = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

export const FieldLabel = styled.label`
  font: ${({ theme }) => theme.fonts.textMiddleBold};
  color: ${({ theme }) => theme.colors.greys.darkest};
`;

export const RequiredStar = styled.span`
  color: ${({ theme }) => theme.colors.infoRed};
  margin-right: 4px;
`;

export const InputFieldWrapper = styled.div`
  max-width: 280px;
  width: 100%;
`;

export const TabsSection = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  flex: 1 1 auto;
  overflow-y: auto;
`;

export const HeaderContainer = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CloseButton = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  height: 32px;
  justify-content: center;
  padding: 4px;
  width: 32px;
  &:hover {
    opacity: 0.7;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export const FooterContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  margin-top: auto;
`;

export const ContentContainer = styled.div`
  padding: 24px 0;
  overflow: visible;
  display: flex;
  flex-direction: column;
  row-gap: 24px;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;

  margin-right: 8px;

  > img {
    width: 20px;
    height: 23px;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const StyledTable = styled(Table)`
  border-collapse: separate;
  border-spacing: 0 12px;
  width: auto;
`;

export const StyledTableRow = styled(TableRow)`
  background: ${({ theme }) => theme.colors.greys.lightest};
  height: 40px;

  padding: 12px 16px;

  & td {
    padding: 12px 16px;
    border-top: 1px solid ${({ theme }) => theme.colors.greys.light};
    border-bottom: 1px solid ${({ theme }) => theme.colors.greys.light};
    border-left: none;
    border-right: none;
  }
  & td:first-child {
    border-radius: 8px 0 0 8px;
    border-left: 1px solid ${({ theme }) => theme.colors.greys.light};
  }
  & td:last-child {
    border-radius: 0 8px 8px 0;
    border-right: 1px solid ${({ theme }) => theme.colors.greys.light};
    padding-left: 58px;
  }
`;

export const StyledHeaderRow = styled(TableRow)`
  & th {
    border: none;
    color: ${({ theme }) => theme.colors.greys.dark};
    font-size: 14px;
    font-weight: 400;
    padding-bottom: 4px;
    line-height: 16px;
  }
`;

export const Divider = styled.div`
  background-color: ${({ theme }) => theme.colors.greys.light};
  flex-shrink: 0;
  height: 1px;
  width: 100%;
  margin-top: -16px;
  margin-bottom: 12px;
`;

export const ErrorText = styled.p`
  color: ${({ theme }) => theme.colors.infoRed};
  font: ${({ theme }) => theme.fonts.textSmall};
  margin-top: 4px;
`;
